import { useCallback } from 'react';
import { useIsMobile } from '@/hooks';
import { cn } from '@/utils';
import TrophyIcon from '../../assets/icons/resources-header-trophy.svg?react';
import { useResourcesGuide } from '../../contexts/resources-guide.context';

interface ResourcesTrophyButtonProps {
	className?: string;
	layout: 'mobile' | 'web';
}

export function ResourcesTrophyButton({ className, layout }: ResourcesTrophyButtonProps) {
	const isMobile = useIsMobile();
	const { isEnabled, registerTrophyAnchor, openGuide, showPulse } = useResourcesGuide();
	const shouldRegisterAnchor = layout === 'mobile' ? isMobile : !isMobile;

	const handleAnchorRef = useCallback(
		(element: HTMLElement | null) => {
			if (!shouldRegisterAnchor) return;
			registerTrophyAnchor(element);
		},
		[registerTrophyAnchor, shouldRegisterAnchor]
	);

	if (!isEnabled) return null;

	return (
		<div className={cn('relative size-8 shrink-0', className)}>
			{showPulse && (
				<span
					className="icon-pulse-ring pointer-events-none absolute inset-0 rounded-lg border-[0.5px] border-[#5583F6]"
					aria-hidden="true"
				/>
			)}
			<button
				ref={handleAnchorRef}
				type="button"
				onClick={openGuide}
				className="relative flex size-8 items-center justify-center rounded-lg border-[0.5px] border-[#DCE3F9] bg-white shadow-[0_1px_2px_rgba(12,12,13,0.05)] transition-colors hover:bg-[#F8FAFC] focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-custom-2"
				aria-label="Open Grand Slam Challenge guide"
			>
				<TrophyIcon className="size-4 shrink-0" aria-hidden="true" />
			</button>
		</div>
	);
}
